import React from 'react';

const ScSpinner = ({ label = 'Loading...' }) => (
  <div className="sc-spinner">
    <div className="sc-spinner-ring" />
    <span>{label}</span>
  </div>
);

export default ScSpinner;
